import type { MarketPoint } from "../market-data/types";
import type { ScaleState } from "./scale";

export function hexToRgba(hex: string, alpha: number): string {
  if (!hex.startsWith("#")) return hex;
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

export function detectMomentum(points: MarketPoint[], visibleCount: number, scale: ScaleState) {
  const lookback = 6;
  if (visibleCount <= lookback) return { direction: 0, intensity: 0, delta: 0 };
  const now = points[visibleCount - 1];
  const before = points[visibleCount - 1 - lookback];
  const delta = now.y - before.y;
  const threshold = scale.halfRange * 0.19;
  const intensity = Math.min(1, Math.max(0, (Math.abs(delta) - threshold) / (scale.halfRange * 0.36)));
  if (intensity <= 0) return { direction: 0, intensity: 0, delta };
  return { direction: delta > 0 ? 1 : -1, intensity, delta };
}

export function seededNoise(seed: number): number {
  const x = Math.sin(seed * 12.9898) * 43758.5453;
  return x - Math.floor(x);
}
